import axios from 'axios';

import { apiUrl } from '../../pro/config';

const defaultError = {
    app: 'react-pro',
    title: 'Uncaught error',
    message: 'Uncaught error',
    page: window.location.href,
    file: undefined,
    line: undefined,
    code: undefined,
    trace: '',
};

export default class ErrorHandler {

    constructor() {
        this.report = this.report.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    async sendError(error) {
        const headers = {};
        if (window.YP_API && window.YP_API.ACCESS_TOKEN ? window.YP_API.ACCESS_TOKEN : false) {
            headers.Authorization = `Bearer ${window.YP_API.ACCESS_TOKEN}`;
        }
        axios.post(`${apiUrl}/god`, {
            ...defaultError,
            title: `${error.name}::${error.message}`,
            message: error.message,
        }, { headers })
            .then(() => {
                // eslint-disable-next-line no-console
                console.warn(`Error has been sent : ${error.name}::${error.message}`);
            })
            .catch((e) => {
                // eslint-disable-next-line no-console
                console.error('Error while sending error', e);
            });
    }

    async handleError(error) {
        try {
            await this.sendError(error);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('ErrorsHelpers::handleError', e);
        }
    }

    report(error) {
        this.handleError(error);
    }

}
